import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { api } from './api';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import BrowsePage from './pages/BrowsePage';
import WatchPage from './pages/WatchPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';
import ProfilePage from './pages/ProfilePage';
import VODPage from './pages/VODPage';
import ClipPage from './pages/ClipPage';
import CategoriesPage from './pages/CategoriesPage';
import FollowingPage from './pages/FollowingPage';
import SettingsPage from './pages/SettingsPage';
import GuidelinesPage from './pages/GuidelinesPage';
import AdminPage from './pages/AdminPage';
import SponsorsPage from './pages/SponsorsPage';
import PartnersPage from './pages/PartnersPage';
import CareersPage from './pages/CareersPage';
import ChatOverlay from './pages/ChatOverlay';
import CopyrightPage from './pages/CopyrightPage';
import OBSStreamManager from './pages/OBSStreamManager';
import OBSChat from './pages/OBSChat';
import './App.css';

export const AuthContext = React.createContext(null);

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.me()
        .then(d => setUser(d.user))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    api.logout().catch(() => {});
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) return <div className="loading-screen">Loading...</div>;

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      <BrowserRouter>
        <Routes>
          {/* OBS routes — no navbar/sidebar */}
          <Route path="/:username/chat-overlay" element={<ChatOverlay />} />
          <Route path="/obs/stream-manager" element={<OBSStreamManager />} />
          <Route path="/obs/chat" element={<OBSChat />} />

          {/* Main app routes */}
          <Route path="*" element={
            <>
              <Navbar />
              <div className="app-layout">
                <Sidebar />
                <div className="app-content">
                  <Routes>
                    <Route path="/" element={<BrowsePage />} />
                    <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
                    <Route path="/signup" element={user ? <Navigate to="/" /> : <SignupPage />} />
                    <Route path="/dashboard" element={user ? <DashboardPage /> : <Navigate to="/login" />} />
                    <Route path="/settings" element={user ? <SettingsPage /> : <Navigate to="/login" />} />
                    <Route path="/categories" element={<CategoriesPage />} />
                    <Route path="/following" element={user ? <FollowingPage /> : <Navigate to="/login" />} />
                    <Route path="/guidelines" element={<GuidelinesPage />} />
              <Route path="/copyright" element={<CopyrightPage />} />
                    <Route path="/sponsors" element={<SponsorsPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/admin" element={user?.is_admin ? <AdminPage /> : <Navigate to="/" />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/:username" element={<ProfilePage />} />
                    <Route path="/:username/watch" element={<WatchPage />} />
                    <Route path="/:username/videos/:vodId" element={<VODPage />} />
                    <Route path="/clips/:clipId" element={<ClipPage />} />
                  </Routes>
                </div>
              </div>
            </>
          } />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
